import React from "react";
import { motion } from "framer-motion";
import { Zap, Wrench } from "lucide-react";

const TopBannerSection = () => {
  const bannerVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  return (
    <motion.section
      className="py-4 md:py-6 mt-10 bg-gradient-to-r from-primary via-purple-600 to-accent text-primary-foreground shadow-md"
      variants={bannerVariants}
      initial="hidden"
      animate="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className="container mx-auto px-4 text-center">
        <motion.div
          className="flex items-center justify-center mb-2"
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.4 }}
        >
          <Zap className="h-6 w-6 md:h-8 md:w-8 text-yellow-300 mr-2" />
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold tracking-tight text-background">
            Driven by Innovation.{" "}
            <span className="inline-block">Powered by Parts.</span>
          </h1>
          <Wrench className="h-6 w-6 md:h-8 md:w-8 text-yellow-300 ml-2 transform -scale-x-100" />
        </motion.div>
        <motion.p
          className="text-sm md:text-base text-background/90 max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.4 }}
        >
          Welcome to PartsLokator — the smart way to buy and sell used auto
          parts.
        </motion.p>
      </div>
    </motion.section>
  );
};

export default TopBannerSection;
